// Store sidebar. Each link is gated to the same roles as its page.
import HasRole from "modules/5_view_helpers/HasRole";
import { createCustomFormLinks, createMenuItems } from "../helpers";

const getStoreNav = (store_nav_custom_forms_links, store_nav_menus) => {
  let items = [];

  const StoreModuleRole = HasRole({ name: "Store_Module_Access" });
  if (StoreModuleRole) {
    items.push({
      icon: "fa fa-home",
      label: "Home",
      to: `/store`,
    });
  }

  const StoreRequestRoles =
    HasRole({ resource_type: "Store::Request", name: ["create", "moderator"] }) || HasRole({ name: "Show_All_Store_Requests" });
  if (StoreRequestRoles) {
    items.push({
      icon: "fa fa-clipboard",
      label: "Store Requests",
      to: `/store/requests`,
    });
  }

  const BookoutItemRoles = HasRole({ resource_type: "Store::BookoutItem", name: ["read", "moderator"] });
  if (BookoutItemRoles) {
    items.push({
      icon: "fa fa-arrow-right",
      label: "Bookout Items",
      to: `/store/bookout_items`,
    });
  }

  const OverallRoles = HasRole({ resource_type: "Store::Overall", name: ["read", "moderator"] });
  if (OverallRoles) {
    items.push({
      icon: "fa fa-shield",
      label: "Overalls",
      to: `/store/overalls`,
    });
  }

  const SettingsRoles = HasRole({ resource_type: "GlobalSetting", name: ["read", "update", "moderator"] });
  if (SettingsRoles) {
    items.push({
      icon: "fa fa-cog",
      label: "Settings",
      to: `/store/settings`,
    });
  }

  items = _.concat(items, createCustomFormLinks(store_nav_custom_forms_links), createMenuItems(store_nav_menus));

  items.push({
    icon: "fa fa-arrow-left",
    label: "Back To Lion",
    to: `/`,
    external: true,
  });

  return items;
};

export default getStoreNav;
